<div mat-dialog-title>
  <div class="dialog-header-title">{{ data.title }}</div>
</div>

<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button class="accent-button" (click)="close()">Annuler</button>
  <button mat-raised-button class="accent-button" (click)="confirm()">Confirmer</button>
</mat-dialog-actions>
